import React from "react";
import { LayoutGrid, List } from "lucide-react";
import { useLang } from "@/lib/lang";

/**
 * View toggle: switches between card (detailed) and list (compact) modes.
 * Persists selection in localStorage under key `ditours_view_${scope}`.
 */
export default function ViewToggle({ scope, value, onChange, testId }) {
  const { t } = useLang();
  const set = (v) => {
    onChange(v);
    try { localStorage.setItem(`ditours_view_${scope}`, v); } catch {}
  };
  return (
    <div className="inline-flex border border-slate-300" data-testid={testId || `view-toggle-${scope}`}>
      <button
        onClick={() => set("cards")}
        data-testid={`${testId || `view-toggle-${scope}`}-cards`}
        aria-pressed={value === "cards"}
        className={`h-9 px-3 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest font-semibold transition-colors ${
          value === "cards" ? "bg-[#0a0f1e] text-white" : "text-slate-700 hover:bg-slate-100"
        }`}
      >
        <LayoutGrid className="w-3.5 h-3.5" /> {t("view_cards") || "Cards"}
      </button>
      <button
        onClick={() => set("list")}
        data-testid={`${testId || `view-toggle-${scope}`}-list`}
        aria-pressed={value === "list"}
        className={`h-9 px-3 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest font-semibold transition-colors border-l border-slate-300 ${
          value === "list" ? "bg-[#0a0f1e] text-white" : "text-slate-700 hover:bg-slate-100"
        }`}
      >
        <List className="w-3.5 h-3.5" /> {t("view_list") || "Lista"}
      </button>
    </div>
  );
}

export function useViewMode(scope, defaultValue = "cards") {
  const [mode, setMode] = React.useState(() => {
    try { return localStorage.getItem(`ditours_view_${scope}`) || defaultValue; }
    catch { return defaultValue; }
  });
  return [mode, setMode];
}
